import axiosInstance from "../../services/axiosInstance";

const getKey = async (vid) => {
  try {
    const response = await axiosInstance.get(`cvacoreservices01/api/vessels/${vid}/vsensor/identity-ref`);
    return response.data;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

export { getKey };